module.exports = __webpack_public_path__ + "media/fonts/Objectivity-Medium-a64e0fdaef0080bbf46d32d5fdb03d28.woff";